import { createUnsafeLinkPath, ensureLeadingSlash } from '@luna/router';

const NEW_BASE_NAMES = [
    {
        rootPath: '/payment-form',
        baseNames: ['/currentAccount', '/saving', '/creditcard'],
    },
];

function inlineBaseNames(names: { rootPath: string; baseNames: string[] }[]) {
    return names
        .map(({ rootPath, baseNames }) => {
            return baseNames.map((baseName) => rootPath + baseName);
        })
        .flat();
}

function replaceRootPath(path: string, names: { rootPath: string; baseNames: string[] }[]): string {
    return names.reduce<string>((result, { rootPath }) => result.replace(rootPath, ''), path);
}

/** the following basenames are used for product pages with the pattern of basename/:accountId */
const listOfProductsURLBasenames = [
    '/currentAccount',
    '/currentAccountArchive',
    '/standing-orders',
    '/saving',
    '/loan',
    '/insurance',
    '/leasing',
    '/pension',
    '/buildingsociety',
    '/creditcard',
    '/debitcard',
    '/securityaccount',
    '/assetManagement',
    '/externalbank',
    '/secondaryId',
    ...inlineBaseNames(NEW_BASE_NAMES),
];

/** the following nested basenames are used for product pages with the pattern of basename/nestedLevel/:accountId */
const listOfNestedProductsURLBasenames = [
    '/securityaccount/gold',
    'orders/upcoming-orders',
    'orders/detail',
];

export const getSelectedProductIdFromURL = (
    currentRoute: string = window.location.hash,
): string | undefined => {
    const path = ensureLeadingSlash(currentRoute);
    if (
        listOfNestedProductsURLBasenames.some((basename) =>
            createUnsafeLinkPath(path).startsWith(createUnsafeLinkPath(basename)),
        )
    ) {
        return path.split('/')?.[3];
    }

    if (
        listOfProductsURLBasenames.some((basename) =>
            createUnsafeLinkPath(path).startsWith(createUnsafeLinkPath(basename)),
        )
    ) {
        return replaceRootPath(path, NEW_BASE_NAMES).split('/')?.[2];
    }

    return undefined;
};
